module.exports = __webpack_public_path__ + "img/eos-model.727e18c1.png";